export default __webpack_public_path__ + "static/media/update.2a716083.svg";